<template>
  <div>
    <BaseChecklist
      v-model="selected"
      :loading="rlsGroupFetching"
      :options="options"
      :label="rlsGroup"
      :search-keys="['text']"
      searchable
    />

    <CompanyRLSGroupChecklistSaveButton />
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  inject,
  provide,
  ref,
  watch
} from '@vue/composition-api'

import { BaseChecklist } from '@components/base'

import CompanyRLSGroupChecklistSaveButton from './CompanyRLSGroupChecklistSaveButton.vue'

export default defineComponent({
  name: 'CompanyRLSGroupChecklist',
  components: {
    BaseChecklist,

    CompanyRLSGroupChecklistSaveButton
  },
  setup() {
    const {
      rlsGroup,
      rlsGroupFetching,
      rlsGroupItems,

      company
    } = inject('company-rls-group')

    const selected = ref([])

    const options = computed(() =>
      rlsGroupItems.value.map((rlsGroupItem) => ({
        value: rlsGroupItem.id,
        text:
          rlsGroupItem[rlsGroup.value] ||
          rlsGroupItem[rlsGroup.value.toLowerCase()]
      }))
    )

    watch(
      company,
      (newCompany) =>
        (selected.value =
          newCompany[`rls_${rlsGroup.value.toLowerCase()}_ids`] || []),
      { deep: true, immediate: true }
    )

    provide('company-rls-group-checklist', {
      selected
    })

    return {
      rlsGroup,
      rlsGroupFetching,

      selected,

      options
    }
  }
})
</script>
